import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, FormikProvider, useFormik } from 'formik';
import { Button } from '@iclinic/design-system';

import {
  billingPhoneSelector,
  nameSelector,
  statusSelector,
} from '../state/selectors';
import { NameInput, PhoneInput } from '../components/index';
import { Actions } from '../components/Actions/Actions';
import * as S from './InputStep.styles';
import { RequestStatus } from 'shared/constants/State';
import { personalFormValidation } from '../validations';
import { submitPersonal, backStep } from '../state/reducer';
import { PersonalStepValues, SignupSteps } from '../state/types';
import { ButtonSubmit } from '../components/Signup.styles';
import { useCheckStep } from '../hooks/useCheckStep';
import { trackSignupStep } from '../trackSignupUtils';
import { trackingStepNames } from '../constants';

const PersonalStepContainer = () => {
  const status = useSelector(statusSelector);
  const dispatch = useDispatch();
  const name = useSelector(nameSelector);
  const billingPhone = useSelector(billingPhoneSelector);
  useCheckStep({ navigationStep: SignupSteps.Personal });

  const handleSubmit = (values: PersonalStepValues) => {
    trackSignupStep({
      name: trackingStepNames[SignupSteps.Job].next,
    });
    dispatch(submitPersonal(values));
  };

  const handleBackStep = () => {
    const previousStep = SignupSteps.Email;
    trackSignupStep({
      name: trackingStepNames[previousStep].back,
    });
    dispatch(backStep(previousStep));
  };

  const formik = useFormik({
    initialValues: {
      name: name || '',
      billingPhone: billingPhone || '',
    },
    onSubmit: handleSubmit,
    validationSchema: personalFormValidation,
  });
  const isLoading = status === RequestStatus.Pending;
  const isDisabled =
    isLoading || !formik.values.name || !formik.values.billingPhone;

  return (
    <FormikProvider value={formik}>
      <Form>
        <S.FormContainer>
          <S.Body variant="xs">Boas-vindas!</S.Body>
          <S.Heading variant="sm">Nos conte um pouco mais de você</S.Heading>
          <NameInput />
          <PhoneInput />
        </S.FormContainer>
        <Actions>
          <Button color="transparent" onClick={handleBackStep}>
            Voltar
          </Button>
          <ButtonSubmit
            color="primary"
            type="submit"
            variant="contained"
            disabled={isDisabled}
            isLoading={isLoading}
          >
            Avançar
          </ButtonSubmit>
        </Actions>
      </Form>
    </FormikProvider>
  );
};

export default PersonalStepContainer;
